export default /* css */ `
.usp {
  font-size: 24px;
  margin-bottom: 24px;
}
`
